<template>
<m-pageframe
    title="{organization-label}: Links"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickCreate()"
                >
                    <v-list-item-title>Create...</v-list-item-title>
                </v-list-item>

                <v-divider
                    v-if="$rc.$state.isAuthActorSystemAdmin()"
                />

                 <v-list-item
                    v-on:click="onClickSyncCalendly()"
                    v-if="$rc.$state.isAuthActorSystemAdmin()"
                >
                    <v-list-item-title>Sync calendly...</v-list-item-title>
                </v-list-item>

            </v-list>


        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickEdit(item)"
                >
                    <v-list-item-title>Edit...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                 <v-list-item
                    v-on:click="onClickDelete(item)"
                >
                    <v-list-item-title>Delete...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>

        <template v-slot:item.purpose="{ item }">
            {{$rc.pretty(item.purpose,'enum_link_purpose')}}
        </template>
    
    </v-data-table>

    <m-edit-link
        ref="edit-dialog"
        v-on:update="doUpdate"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Label', value: 'label'},
                { text: 'URL', value: 'url'},
                { text: 'Purpose', value: 'purpose'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/links',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list links',
            });
        },

        onClickCreate()
        {
            let obj = {
                'organization_id': this.$route.params.organization_id,
                'link_id': this.$rc.uuidv4(),
                'url': 'https://www.redchirp.com',
                'label': 'New Link',
                'purpose': 'not-defined',
            };

            this.$refs['edit-dialog'].showDialog(obj);
        },

        onClickEdit(item)
        {
            this.$refs['edit-dialog'].showDialog(item);
        },

        onClickDelete(item)
        {
            this.$rc.confirm({
                'title': 'Convirm delete link',
                'body': 'Permenantly delete the link: '+item.label+'?',
                'btn_text_ok': 'Delete',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doDelete(item);
                },
            });
        },

        doDelete(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'DELETE: /api/v1/links',
            
                'params' : {
                        'link_id': item.link_id,
                    },
            
                'on_success': (data) => {
                        this.$rc.snackbar("Link deleted");
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to delete link',
            });
        },

        onClickSyncCalendly()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/links/sync-calendly',
            
                'params' : {
                    },
            
                'on_success': (data) => {
                        this.$rc.alert("Sync started","A sync with calendly has been started.  Please give it a few minutes to complete.");
                    },
            
                'on_error': 'Unable to start calendly sync.',
            });
        },
    },
}
</script>

<style lang="scss" scoped>
</style>